import React from 'react';
import { Accordion, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'localization';
import { Proposal } from 'types';

import { LDProposalAccordionButton, Spinner } from 'components';

import { ProposalCard } from '..';

type ProposalsProps = {
  proposals: Proposal[];
  loading: boolean;
  refetch: () => void;
};

const Proposals: React.FC<ProposalsProps> = ({
  proposals,
  loading,
  refetch,
}) => {
  const { t } = useTranslation('component.ldRequests.proposals');

  const [active, setActive] = React.useState<null | Proposal>(null);

  return (
    <Stack w={{ base: '100%' }}>
      <Text fontSize="xl" color="primary">
        {t('inProcessRequests')}
      </Text>
      {loading && (
        <Stack w="100%" py={4} justify="center" align="center">
          <Spinner />
        </Stack>
      )}
      {proposals.length === 0 && (
        <Stack w="100%" py={4} justify="center" align="center">
          <Text>{t('noProposal')}</Text>
        </Stack>
      )}
      <Accordion.Root
        collapsible
        w="100%"
        onValueChange={(details: { value: string[] }) =>
          ((active: unknown) => {
            if (proposals && active !== null) {
              setActive(
                proposals.filter(
                  (proposal) =>
                    !['FAILED', 'COMPLETED'].includes(proposal.status)
                )[active as number]
              );
            }
          })(details.value)
        }
      >
        {proposals
          .filter((proposal) => proposal.status !== 'COMPLETED')
          .map((proposal) => {
            return (
              <Stack key={proposal.id} w="100%">
                <Accordion.Item
                  w="100%"
                  bgColor={active?.id === proposal.id ? 'lightPrimary' : ''}
                  value="item-0"
                >
                  <LDProposalAccordionButton
                    createdAt={proposal.created_at}
                    username={
                      proposal?.source_wallet?.user?.ld_contract?.nick_name ||
                      ''
                    }
                    status={proposal.status}
                    panel="USER"
                    transaction_type="DEPOSIT"
                  />
                  <ProposalCard proposal={proposal} refetch={refetch} />
                </Accordion.Item>
              </Stack>
            );
          })}
      </Accordion.Root>
    </Stack>
  );
};
export default Proposals;
